import {
  WSActions,
  WSElement,
  WSSectionToolbar,
  WSTable,
  WSTableCell
} from "@wingspanhq/fe-component-library";
import { IWorkLog } from "@wingspanhq/payments/dist/interfaces";
import queryString from "qs";
import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryWorkLogs } from "../../../query/workLog/queries/useQueryWorkLogs";
import { usePayablesMap } from "../hooks/usePayablesMap";
import { getPathWorkLogPayerDetails, PATH_WORK_LOGS_PAYER } from "../paths";
import { getWorkLogPayerStatusCellProps } from "../utils/getWorkLogPayerStatusCellProps";
import { createListRequest } from "./TableWorkLogsPayerView/filters/request";
import { Filter } from "./TableWorkLogsPayerView/filters/types";

type Props = {
  filter?: Filter;
};

export const WidgetWorkLogsPayerView: React.FC<Props> = ({ filter }) => {
  const userId = useUserId();
  const history = useHistory();

  // Build API request with 5-item page size
  const request = useMemo(
    () => ({
      ...createListRequest(userId, filter),
      page: { size: 5, number: 1 }
    }),
    [userId, filter]
  );

  const queryWorkLogs = useQueryWorkLogs(request);
  const { payablesMap } = usePayablesMap(queryWorkLogs.data);

  if (!queryWorkLogs.data?.length) {
    return null;
  }

  return (
    <WSElement>
      <WSSectionToolbar title="Work logs" mb="S" />

      <WSTable<IWorkLog>
        tableData={(queryWorkLogs.data || []).map(workLog => ({
          id: workLog.workLogId,
          data: workLog
        }))}
        onRowClick={row => {
          history.push(getPathWorkLogPayerDetails(row.id));
        }}
        columns={[
          {
            config: {
              header: { text: "Work logs" },
              gridTemplateSizeMax: "2fr"
            },
            renderFunction: ({ data }) => (
              <WSTableCell text={data.workLogNumber} />
            )
          },
          {
            config: {
              header: { text: "Status" }
            },
            renderFunction: ({ data }) => {
              const payable = payablesMap?.get(data.invoiceId || "");

              const cellProps = getWorkLogPayerStatusCellProps({
                workLog: data,
                payable
              });

              return <WSTableCell {...cellProps} />;
            }
          }
        ]}
      />

      <WSActions
        alignment="left"
        size="M"
        mt="M"
        buttons={[
          {
            label: "View all",
            kind: "Link",
            onClick: () => {
              const query = queryString.stringify({
                filter: filter || {}
              });
              history.push(`${PATH_WORK_LOGS_PAYER}?${query}`);
            }
          }
        ]}
      />
    </WSElement>
  );
};
